import React from "react"
import { useSelector } from "react-redux"

// Components
import Popup from "@modules/popup/Popup"
import LazyRender from "@ng-mw/reol/components/LazyRender"
import { ForcedUpgrade } from "../loaders"
import { RootState } from "@app/types"

const OsUpgradePopup = () => {
    const isOpen = useSelector((state: RootState) => state.app.osUpgradePopup.visible)

    return (
        <Popup isOpen={isOpen}>
            <LazyRender
                isVisible={isOpen}
                hiddenClassName=""
                className="forced-upgrade__container"
            >
                <ForcedUpgrade isOS={true} />
            </LazyRender>
        </Popup>
    )
}

export default OsUpgradePopup
